/**
 * Mockup v3 P5 (Diseño): the strings of the secondary colour, the Google font families, the 12 px
 * corner, the rename, the SVG logo drop zone and "Activo en" per scope. Spread into `es` by
 * `es.ts`; P5 adds its keys here only.
 *
 * One `design.font.<family>` per Google family of the contract table; the key is the literal in
 * camel case because a dictionary key is letters only (`source-serif-4` is `sourceSerifFour`).
 */
export const esDesign = {
  "design.role.secondary": "Secundario",
  "design.pair.textOnSecondary": "Texto sobre el secundario",
  "design.palette.status": "Colores de estado",
  "design.font.group.google": "Google Fonts",
  "design.font.group.system": "Fuentes del sistema",
  "design.font.inter": "Inter",
  "design.font.poppins": "Poppins",
  "design.font.manrope": "Manrope",
  "design.font.dmSans": "DM Sans",
  "design.font.montserrat": "Montserrat",
  "design.font.roboto": "Roboto",
  "design.font.lato": "Lato",
  "design.font.sourceSerifFour": "Source Serif 4",
  "design.font.playfairDisplay": "Playfair Display",
  "design.font.merriweather": "Merriweather",
  "design.font.ibmPlexMono": "IBM Plex Mono",
  "design.radius.rounded": "12",
  "design.radius.round": "Redondeado",
  "design.radius.legacy": "16 (anterior)",
  "design.radius.label": "Esquinas",
  "design.rename.action": "Renombrar el perfil",
  "design.rename.save": "Guardar",
  "design.rename.cancel": "Cancelar",
  "design.rename.hint": "Renombrar no crea una versión nueva.",
  "design.rename.taken": "Ya existe un perfil con ese nombre en este ámbito.",
  "design.logo.drop": "Arrastra el logo aquí o elige un archivo",
  "design.logo.types": "SVG, PNG, JPEG o WebP, hasta 512 KB",
  "design.logo.badType": "El logo debe ser SVG, PNG, JPEG o WebP.",
  "design.logo.tooBig": "El logo supera 512 KB.",
  "design.activeIn.on": "Activo",
  "design.activeIn.now": "Ahora: «{name}»",
  "design.activeIn.system": "Diseño del sistema",
  "design.activeIn.notAllowed": "Este perfil no se puede activar en este ámbito.",
  "design.activeIn.help":
    "Un ámbito usa un solo perfil a la vez: activarlo aquí lo quita del que lo tuviera. Los mockups nuevos de ese ámbito lo usarán; los existentes no cambian.",
  "design.zero.title": "Crear tu primer perfil",
  "design.sample.title": "Abre tu cuenta en 5 minutos",
  "design.sample.label": "Muestra de la tipografía",
  "design.sample.specimen": "Aa Bb Cc 0123 ñ á",
  // Owner 2026-10-19 (answer 4A): "Duplicar y editar" is an instant copy; the copy opens at once.
  "design.duplicate.done": "Se creó la copia del perfil. Ya puedes editarla.",
  "design.duplicate.failed": "No se pudo duplicar el perfil. Inténtalo de nuevo.",
} as const;
